// This adapter only shapes input for the existing schedule draft and save flow.
const string = { type: "string" };
const strings = { type: "array", items: string };
const tool = (name, description, properties = {}, required = Object.keys(properties)) => ({
  type: "function", name, description,
  parameters: { type: "object", properties, required, additionalProperties: false },
});
export const scheduleTools = [
  tool("get_schedule_context", "Hämta aktuella personer, projekt, utkast och sparade pass. Gör detta före varje ändring."),
  tool("set_schedule_draft", "Skapa eller ersätt hela utkastet i gränssnittet. Personer och projekt anges med befintliga ID. Bevara oförändrade delar vid följdkommandon.", {
    employeeIds: strings,
    rows: { type: "array", items: { type: "object", additionalProperties: false, required: ["date", "blocks"], properties: {
      date: string, blocks: { type: "array", items: { type: "object", additionalProperties: false, required: ["startTime", "endTime", "projectIds"], properties: { startTime: string, endTime: string, projectIds: strings } } },
    } } },
  }),
  tool("plan_monthly_schedule", "Använd alltid befintlig schemamotor för månadsschema med procent eller totalt antal timmar. Beskrivningen ska innehålla explicit svensk månad och år samt önskad procent/timmar och eventuell timfördelning per projektnamn.", { description: string, employeeIds: strings, projectIds: strings }),
  tool("save_schedule_draft", "Spara det aktuella utkastet med befintlig sparfunktion när användaren bett att lägga in passen."),
  tool("change_saved_shift", "Ändra eller flytta ett befintligt opublicerat pass. Alla fält krävs; behåll oförändrade värden från kontexten.", {
    shiftId: string, date: string, startTime: string, endTime: string, employeeIds: strings, projectId: string,
  }),
  tool("delete_saved_shift", "Ta bort ett specifikt opublicerat pass som användaren bett att ta bort.", { shiftId: string }),
  tool("end_conversation", "Avsluta mikrofonen när användaren säger avsluta samtalet."),
];
export function validateSlot(date, startTime, endTime) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(Date.parse(`${date}T12:00:00Z`)) || new Date(`${date}T12:00:00Z`).toISOString().slice(0, 10) !== date) throw new Error("Ange ett giltigt datum.");
  if (![startTime, endTime].every((value) => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(value)) || startTime === endTime) throw new Error("Ange giltiga start- och sluttider.");
}
export function resolveIds(ids, items, label) {
  if (!Array.isArray(ids) || !ids.length || ids.length > 100 || new Set(ids).size !== ids.length) throw new Error(`Välj ${label}.`);
  return ids.map((id) => {
    const item = items.find((candidate) => candidate.id === id);
    if (!item) throw new Error(`Okänd ${label}. Hämta aktuell kontext.`);
    return item;
  });
}
export function buildRealtimeDraft(input, employees, projects) {
  const selected = resolveIds(input.employeeIds, employees, "person");
  if (!Array.isArray(input.rows) || !input.rows.length || input.rows.length > 62) throw new Error("Välj 1–62 datum.");
  let count = 0;
  const rows = input.rows.map((row) => {
    if (!Array.isArray(row.blocks) || !row.blocks.length) throw new Error("Pass saknas.");
    return { date: row.date, blocks: row.blocks.map((block) => {
      validateSlot(row.date, block.startTime, block.endTime);
      const selectedProjects = resolveIds(block.projectIds, projects, "projekt");
      count += selectedProjects.length;
      if (count > 400) throw new Error("Högst 400 pass åt gången.");
      return { startTime: block.startTime, endTime: block.endTime, projects: selectedProjects };
    }) };
  });
  const blocks = rows.flatMap((row) => row.blocks);
  return { employees: selected, rows, blocks, dates: rows.map((row) => row.date), projects: [...new Map(blocks.flatMap((block) => block.projects).map((project) => [project.id, project])).values()], startTime: blocks[0].startTime, endTime: blocks[0].endTime };
}
